import {MyopMessages} from "../../common/MyopMessages";
import {myopAttributes} from "../../consts";
import {BaseMessageHandler} from "../../common";
import {HostSDK} from "../../host/hostSDK";
import {CreateRefComponentMessage, RefComponentCreatedMessage} from "../../messages/CreateRefComponentMessage.ts";
import {IMyopComponent} from "../../host";

export class CreateRefComponentMessageHandler extends BaseMessageHandler<CreateRefComponentMessage> {

    messageType = MyopMessages.CreateRefComponentMessage;

    executor = (event: CreateRefComponentMessage) => {
        const createRef = async () => {
            //TODO : use ref helper here
            const allItems = document.querySelectorAll<HTMLElement>(`[${myopAttributes.id}='${event.refConfig.selector}']`);
            if (allItems.length === 1) {
                const hostSDK = HostSDK.Instance();
                const refComponent = await hostSDK.loadComponent(event.nestedComponentConfig,
                    allItems.item(0),
                    event.options)

                // we need it to pass the assigned ids
                const nestedRefConfig: any[] = [];

                Object.keys(refComponent.refs).forEach(refName => {
                    let ref = refComponent.refs[refName];
                    ref = ref.__nonProxied || ref;

                    //debugger;
                    if ((ref as IMyopComponent).componentDefinition) {
                        nestedRefConfig.push({
                            refName,
                            componentDefinitionId: (ref as IMyopComponent).componentDefinition.id,
                        });
                    }
                })

                //debugger;

                this.messageToHost(new RefComponentCreatedMessage(event.handlerUniqueId, nestedRefConfig));
            } else {
                console.error('CreateRefComponentMessageHandler - DOM element not found')
                this.messageToHost(new RefComponentCreatedMessage(event.handlerUniqueId, [], true));
                debugger;
            }
        }

        createRef().then();
        //returning undefined so it won't act as a cleanup
    }
}
